module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/hourglass-e902a8b261e1266b85fa837aec38e571.png";